// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-Blocks-Subheading-editor-SubheadingEditor-module__container";
export { _1 as "container" }
